import {map} from 'ramda';

import {VehicleModel} from '@dms/api/shared';

export const getModelOptions = map((model: VehicleModel) => ({
  label: model.default_label,
  value: model.model,
}));
